import type { BlockCityGuides } from 'types/block-city-guides';
import React from 'react';
import { Wrap } from '@leafwell/components';
import HeadingBody from './heading-body';
import { useWordPressContext } from 'contexts/wordpress-provider';

const CityGuides: React.FC<BlockCityGuides> = ({ sectionId, title }) => {
  const { cityGuides } = useWordPressContext();
  return (
    <Wrap id={sectionId} className="!gap-y-4">
      {title?.length > 0 && (
        <HeadingBody className="" level="2" title={title} />
      )}
      {cityGuides?.length > 0 && (
        <ul className="grid gap-y-1 list-disc list-inside marker:text-lilac-300">
          {cityGuides.map(({ city, link }, idx) => {
            return (
              <li key={idx}>
                <a
                  href={link}
                  target="_blank"
                  className="relative underline-offset-small cursor-pointer focus:outline-none outline-none no-underline hover:underline hover:text-lilac-500 underline-thickness-medium select-none no-drag leading-loose"
                >
                  {city}
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </Wrap>
  );
};

export default CityGuides;
